export default __webpack_public_path__ + "static/media/image4.dbefe717.png";